// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3eGDH","title":"Header_title__2j2xl","side":"Header_side__2dovj"};